import {
  Box, Button, Collapse, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, IconButton, Stack, Table,
  TableBody, TableCell, tableCellClasses, TableHead, TableRow,
  styled, FormControlLabel, Switch, Accordion, AccordionSummary,
  Typography, ListItemText, AccordionDetails, Card, CardContent,
  CardActions, Divider, ListItem, List
} from "@mui/material";
import { Dispatch, FC, SyntheticEvent, useState } from "react";
import { cellStyle } from "../Pays/RowPays";
import { btnStyle } from "../user/Tabs/utilisateur/UtilisateurRow";
import { DataOperation, FirstPivot } from "./Operation";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { LoadingButton } from "@mui/lab";
import { AxiosInstance } from "axios";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import OperationForm from "../../../forms/operation/OperationForm";
import { AlertType } from "../../../../types/AlertType";
import { DataRef } from "../../../../types/DataRef";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addArticleInformationParam } from "../../../../redux/actions/articleParam";
import ArticleInformation from "../../../../types/ArticleInformation";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArticleIcon from "@mui/icons-material/Article";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import ChangeStatusConfirmation from "../../../element/ChangeStatusConfirmation";
import DesactiveDateModal from "../../../element/DesactiveDateModal";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

interface OperationRowsProps {
  isDesktopOrLaptop: boolean;
  operation: DataOperation;
  http: AxiosInstance;
  dataClients: DataRef[];
  dataSocieteFacturations: DataRef[];
  dataSecteurActivites: DataRef[];
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
  expanded: number | false;
  setExpanded: Dispatch<React.SetStateAction<number | false>>;
  reloadList: () => void;
  periodeRefAll: DataRef[];
}

const OperationRow: FC<OperationRowsProps> = ({
  isDesktopOrLaptop,
  operation,
  http,
  dataClients,
  dataSocieteFacturations,
  dataSecteurActivites,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  reloadList,
  periodeRefAll,
  expanded,
  setExpanded
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = useState<boolean>(false);
  const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [desactiveDateModal, setDesactiveDateModal] = useState<boolean>(false);

  const [changeStatut, setChangeStatut] = useState<boolean>(false);

  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    setDeleteLoading(true);
    await http
      .delete(`operation/delete/${operation?.id}`)
      .then(() => {
        setAlerteMessage("Suppression efféctuée !");
        setAlertType("success");
        setOpenSnack(true);
        reloadList();
      })
      .catch((error) => {
        console.log(error);
        setAlertType("error");
        setOpenSnack(true);
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleChangeState = () => {
    operation?.actif ? setDesactiveDateModal(true) : setChangeStatut(true);
  };

  const handleClose1 = () => {
    setChangeStatut(false);
  };

  const handleClose2 = () => {
    setDesactiveDateModal(false);
  };

  const handleChangeAccordionValue = (panel: number) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const navigateToArticle = (code: FirstPivot) => {
    // Parametre Avec Redux
    const articleToRedux: ArticleInformation = {
      idPivot: code?.id as number,
      idCodeGesco:
        code?.piv_socifact_code_gescos?.code_gesco
          ?.id,
      idOPeration: operation?.id,
      idSociete:
        code?.piv_socifact_code_gescos
          ?.societe_facturation?.id,
      idClient: operation?.client?.id,
    };
    dispatch(
      addArticleInformationParam(articleToRedux)
    );

    // Navigation
    navigate("/article");
  };

  const secteurActiviteText = () => {
    const secteurActiviteArray = operation?.secteur_activites?.map(elem => elem?.libelle);

    return secteurActiviteArray.join(' / ');
  }

  const hasOperations = operation?.pivot_oper_socifact_code_gesco?.find(
    (elem) => elem?.articles?.length > 0
  );

  const confirmMsgForStatut = `Vous êtes sur le point ${operation?.actif ? "de Désactiver" : "d'Activer"} cette opération ainsi que leur articles,
  êtes-vous sûr de vouloir poursuivre cette action ?`;

  const url = `operation/change-statut/${operation?.id}`;

  return (
    <>
      {isDesktopOrLaptop ? (
        <>
          <TableRow>
            <TableCell align="center">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
                sx={{ color: "#fff", fontSize: 12 }}
                disabled={!operation?.actif}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
            <TableCell align="center" sx={{ color: "#FFF" }}>
              {operation?.client?.libelle}
            </TableCell>
            <TableCell align="center" sx={{ color: "#FFF" }}>
              {operation?.libelle}
            </TableCell>
            <TableCell align="center" sx={{ color: "#FFF" }}>
              {secteurActiviteText()}
            </TableCell>
            <TableCell>
              <Stack
                direction="row"
                spacing={1}
                display="flex"
                justifyContent="center"
              >
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<BorderColorIcon />}
                  onClick={() => setOpenModal(true)}
                  sx={btnStyle({
                    bgColor: "#070d23",
                    hoverColor: "Gray",
                    color: "#fff",
                  })}
                  disabled={!operation?.actif}
                >
                  Modifier
                </Button>

                <Button
                  size="small"
                  variant="outlined"
                  disabled={(hasOperations || !operation?.actif) && true}
                  startIcon={<DeleteForeverIcon />}
                  onClick={() => setOpenModalDelete(true)}
                  sx={btnStyle({
                    bgColor: "#FF0000",
                    hoverColor: "#FE3737",
                  })}
                >
                  Supprimer
                </Button>

                <FormControlLabel
                  sx={{ mt: 1, color: '#818181' }}
                  control={<Switch
                    name="consentement"
                    checked={operation?.actif}
                    onChange={() => handleChangeState()}
                    color="warning"
                    size="small"
                    inputProps={{ 'aria-label': 'controlled' }}
                  />}
                  label={operation?.actif ? "Activer" : "Désactiver"}
                />
              </Stack>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell style={cellStyle} colSpan={5}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell style={cellStyle} align="center">
                          Société de facturation
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Code gesco
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Intitulé tiers
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Periode De Facturation
                        </StyledTableCell>
                        <StyledTableCell style={cellStyle} align="center">
                          Action
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {operation?.pivot_oper_socifact_code_gesco.map(
                        (code, index) => (
                          <TableRow key={index}>
                            <TableCell style={cellStyle} align="center">
                              {
                                code?.piv_socifact_code_gescos?.societe_facturation
                                  ?.libelle
                              }
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {code?.piv_socifact_code_gescos?.code_gesco?.libelle}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {code?.piv_socifact_code_gescos?.code_gesco?.intituleTiers}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              {code?.periode_facturation?.libelle}
                            </TableCell>
                            <TableCell style={cellStyle} align="center">
                              <Button
                                size="small"
                                variant="contained"
                                startIcon={<ArticleIcon />}
                                color="warning"
                                onClick={() => navigateToArticle(code)}
                                sx={{ textTransform: "none" }}
                              >
                                Article
                              </Button>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      ) : (
        <Accordion
          expanded={expanded === operation?.id}
          onChange={handleChangeAccordionValue(operation?.id)}
          sx={{
            borderRadius: 1,
            bgcolor: '#fff',
            mb: 1,
            ml: 0.1
          }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#080d24' }} />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Stack direction="column">
              <List sx={{ py: 0 }} dense>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Opération :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {operation?.libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Client :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {operation?.client?.libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Secteur d'activité :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: '#FC8404' }}>
                        {secteurActiviteText()}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Statut :"
                    secondary={
                      <FormControlLabel
                        sx={{ color: 'GrayText', fontSize: 6 }}
                        control={<Switch
                          checked={operation?.actif}
                          onChange={() => handleChangeState()}
                          color="warning"
                          size="medium"
                          inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        label={
                          <Typography variant="subtitle2">
                            {operation?.actif ? "Activer" : "Désactiver"}
                          </Typography>
                        }
                      />
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Stack direction='column' spacing={1}>
              <Button
                variant="contained"
                sx={btnStyle({
                  bgColor: "Gray",
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                size='small'
                fullWidth
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
                disabled={!operation?.actif}
              >
                Modifier
              </Button >
              <Button
                size="small"
                variant="contained"
                sx={btnStyle({
                  bgColor: "#FF0000",
                  hoverColor: "#FE3737",
                })}
                fullWidth
                startIcon={<DeleteIcon />}
                onClick={() => setOpenModalDelete(true)}
                disabled={(hasOperations || !operation?.actif) && true}
              >
                Supprimer
              </Button>

              <Box>
                <Box mt={3}>
                  <Typography gutterBottom variant="h5" component="div" sx={{ mb: 0 }}>
                    Codes Gesco associé
                  </Typography>
                  <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 1 }} />
                </Box>
              </Box>

              {operation?.pivot_oper_socifact_code_gesco.map((code) => (
                <Card key={code.id}>
                  <CardContent>
                    <List dense>
                      <ListItem dense>
                        <ListItemText
                          primary="Société de facturation :"
                          secondary={code?.piv_socifact_code_gescos?.societe_facturation?.libelle}
                        />
                      </ListItem>
                      <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                      <ListItem dense>
                        <ListItemText
                          primary="Code gesco :"
                          secondary={code?.piv_socifact_code_gescos?.code_gesco?.libelle}
                        />
                      </ListItem>
                      <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                      <ListItem dense>
                        <ListItemText
                          primary="Intitulé tiers :"
                          secondary={code?.piv_socifact_code_gescos?.code_gesco?.intituleTiers}
                        />
                      </ListItem>
                      <Divider orientation="horizontal" sx={{ bgcolor: " #dfdfdf" }} />
                      <ListItem dense>
                        <ListItemText
                          primary="Periode De Facturation :"
                          secondary={code?.periode_facturation?.libelle}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      variant="contained"
                      startIcon={<ArticleIcon />}
                      color="warning"
                      onClick={() => navigateToArticle(code)}
                      sx={{ textTransform: "none" }}
                    >
                      Article
                    </Button>
                  </CardActions>
                </Card>
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}

      <OptionalWidthModal
        title="Modifier une operation"
        onClose={handleClose}
        open={openModal}
        breackPoint="md"
      >
        <OperationForm
          assoc={hasOperations?.id}
          dataClients={dataClients}
          dataSocieteFacturations={dataSocieteFacturations}
          dataSecteurActivites={dataSecteurActivites}
          operation={operation}
          http={http}
          setAlertType={setAlertType}
          setAlerteMessage={setAlerteMessage}
          setOpenSnack={setOpenSnack}
          reloadList={reloadList}
          onClose={handleClose}
          periodeRefAll={periodeRefAll}
        />
      </OptionalWidthModal>

      <Dialog
        open={openModalDelete}
        // TransitionComponent={Transition}
        keepMounted
        onClose={(e) => setOpenModalDelete(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Vous êtes sur le point de supprimer cette operation, êtes-vous sûr
            de vouloir poursuivre cette action ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleDelete()}
            endIcon={<DeleteIcon />}
            loading={deleteLoading}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            Oui
          </LoadingButton>
          <Button
            onClick={(e) => setOpenModalDelete(false)}
            variant="contained"
            color="inherit"
            sx={{ textTransform: "none" }}
            startIcon={<ExitToAppIcon />}
          >
            Non
          </Button>
        </DialogActions>
      </Dialog>

      <ChangeStatusConfirmation
        confirmMessage={confirmMsgForStatut}
        open={changeStatut}
        handleClose1={handleClose1}
        http={http}
        url={url}
        setOpenSnack={setOpenSnack}
        setAlerteMessage={setAlerteMessage}
        setAlertType={setAlertType}
        handleReload={reloadList}
      />

      <DesactiveDateModal
        confirmMessage={confirmMsgForStatut}
        desactiveDateModal={desactiveDateModal}
        handleClose2={handleClose2}
        url={url}
        http={http}
        setOpenSnack={setOpenSnack}
        setAlerteMessage={setAlerteMessage}
        setAlertType={setAlertType}
        handleReload={reloadList}
      />
    </>
  );
};

export default OperationRow;
